import React from "react";
import ProgramPage from "../../components/ProgramPage";

export default function HavenOfHope() {
    return (
        <ProgramPage
            eyebrow="A Program of The Gift of Kindness"
            title="Haven of Hope"
            subtitle="Shelter, safety, and restoration."
            tagline="Everyone deserves a soft place to land."
            hero_image="https://images.unsplash.com/photo-1518398046578-8cca57782e17?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
            intro="Haven of Hope opens doors, hearts, and hands to people experiencing homelessness, domestic crisis, or seasons of instability — providing not just resources, but relationship."
            body_paragraphs={[
                "Sometimes what a person needs most is a meal, a coat, and a room. Sometimes what they need most is someone who will remember their name next week. Haven of Hope shows up with both — practical help and long-term presence.",
                "We work alongside shelters, churches, and community partners to distribute care packages, host warm meals, provide transitional support, and walk with families as they rebuild.",
                "No lecture. No shame. Just a table, a chair, and the belief that dignity is not something you earn — it's something you're born with.",
            ]}
            pillars={[
                { t: "Care Packages", b: "Hygiene kits, warm clothing, and hand-written notes distributed monthly across our partner shelters." },
                { t: "Warm Meals", b: "Community dinners hosted with local partners — anyone at any table, no questions asked." },
                { t: "Bridge Support", b: "Case-by-case help — a security deposit, a bus pass, a work uniform — to bridge someone from crisis to stability." },
            ]}
            verse={{
                text: "Learn to do right; seek justice. Defend the oppressed. Take up the cause of the fatherless; plead the case of the widow.",
                attribution: "Isaiah 1:17",
            }}
            cta_text="Donate or Volunteer"
        />
    );
}
